import React from "react";
import { Link } from "react-router-dom";
import heroBackground from "../assets/img/Hero-SectionImage.jpeg";

export const HeroSection: React.FC = () => {
  const whatsappLink = "https://wa.me/27679376048";

  return (
    <section className="relative overflow-hidden bg-white">
      <div className="absolute inset-0 pointer-events-none">
        <div className="absolute -top-24 -right-24 h-80 w-80 rounded-full bg-secondary/10 blur-3xl" />
        <div className="absolute bottom-0 left-0 h-96 w-96 rounded-full bg-primary/10 blur-3xl" />
      </div>

      <div className="relative z-10 max-w-container-max mx-auto px-md py-xl lg:py-xxl">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-xl items-center min-h-[620px]">
          <div className="space-y-lg">
            <span className="inline-flex items-center gap-sm rounded-full bg-secondary-container px-md py-2 text-secondary font-bold text-xs uppercase tracking-[0.35em]">
              Cleaning and pest services
            </span>

            <div className="space-y-md">
              <h1 className="font-display-lg text-display-lg text-primary text-balance max-w-2xl leading-tight">
                Kolomaka Cleaning Services for homes, businesses, and beyond.
              </h1>
              <p className="font-semibold text-secondary uppercase tracking-[0.22em] text-xs sm:text-sm">
                Kolomaka Cleaning Services and Pest Control
              </p>
              <p className="font-body-lg text-body-lg text-on-surface-variant max-w-xl">
                Transform your space with Kolomaka's expert cleaning and pest
                services. We deliver exceptional results for homes and
                businesses with attention to detail and eco-friendly practices.
              </p>
            </div>

            <div className="flex flex-col sm:flex-row gap-md">
              <a
                className="inline-flex items-center justify-center gap-sm bg-brand-gradient text-on-primary px-lg py-md font-bold rounded-lg shadow-lg hover:brightness-110 transition-all"
                href={whatsappLink}
                target="_blank"
                rel="noreferrer"
              >
                Request a Quote
                <span className="material-symbols-outlined text-[18px]">
                  arrow_forward
                </span>
              </a>
              <Link
                to="/services"
                className="inline-flex items-center justify-center gap-sm border border-outline-variant text-primary px-lg py-md font-bold rounded-lg hover:bg-surface-container transition-all"
              >
                View Services
              </Link>
            </div>

            <div className="grid grid-cols-1 sm:grid-cols-2 gap-md pt-sm max-w-xl">
              <div className="rounded-2xl bg-surface-container-low px-md py-md border border-outline-variant/60">
                <div className="text-primary font-bold text-headline-md">
                  100%
                </div>
                <p className="text-on-surface-variant text-sm">
                  Commitment to quality and satisfaction
                </p>
              </div>
              <div className="rounded-2xl bg-surface-container-low px-md py-md border border-outline-variant/60">
                <div className="text-primary font-bold text-headline-md">
                  Limpopo
                </div>
                <p className="text-on-surface-variant text-sm">
                  Local service for homes and businesses
                </p>
              </div>
            </div>
          </div>

          <div className="relative">
            <div className="relative rounded-[2rem] overflow-hidden shadow-2xl border border-outline-variant bg-surface-container-low">
              <img
                alt="Kolomaka Cleaning Services professional cleaning team"
                className="w-full h-[420px] sm:h-[520px] lg:h-[640px] object-cover"
                src={heroBackground}
                loading="eager"
                decoding="async"
                fetchPriority="high"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-[#00437A]/55 via-[#00437A]/10 to-transparent" />

              <div className="absolute bottom-md left-md right-md sm:bottom-lg sm:left-lg sm:right-lg bg-white/95 backdrop-blur-sm rounded-2xl p-md shadow-xl border border-white/40">
                <div className="grid grid-cols-1 gap-md sm:grid-cols-[1.2fr_0.8fr] sm:items-center sm:gap-md">
                  <div className="text-center sm:text-left">
                    <p className="text-[10px] sm:text-xs uppercase tracking-[0.28em] sm:tracking-[0.3em] text-secondary font-bold mb-2">
                      Trusted service
                    </p>
                    <h2 className="font-headline-md text-[0.95rem] sm:text-headline-md text-primary leading-tight max-w-[12rem] sm:max-w-none mx-auto sm:mx-0">
                      Clean is within our name
                    </h2>
                  </div>
                  <div className="text-center sm:text-right sm:justify-self-end">
                    <p className="font-bold text-primary text-[0.95rem] sm:text-lg mb-1">
                      Call Now
                    </p>
                    <div className="flex flex-col items-center sm:items-end gap-1 leading-snug">
                      <a
                        className="text-secondary font-semibold text-[0.82rem] sm:text-base whitespace-nowrap"
                        href="tel:+27679376048"
                      >
                        +27 67 937 6048
                      </a>
                      <a
                        className="text-secondary font-semibold text-[0.82rem] sm:text-base whitespace-nowrap"
                        href="tel:0781668330"
                      >
                        078 166 8330
                      </a>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div className="absolute -bottom-6 -left-6 hidden lg:block rounded-2xl bg-brand-gradient text-on-primary px-md py-sm shadow-lg">
              <div className="text-xs uppercase tracking-[0.25em] opacity-80">
                Professional results
              </div>
              <div className="font-bold text-lg">For homes and businesses</div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};
